import { render, staticRenderFns } from "./PagamentoCreate.vue?vue&type=template&id=e12beaa2&"
import script from "./PagamentoCreate.vue?vue&type=script&lang=js&"
export * from "./PagamentoCreate.vue?vue&type=script&lang=js&"
import style0 from "./PagamentoCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports